import { Dispatch, SetStateAction } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useSelectTheme } from "../../store";
import { PopupSimple } from "..";
import { useCurrentProjectState } from "../../lib";
import { Legend, ButtonCancel, Button } from "..";

export interface ProjectEditPopPropsT {
  closeAction: Dispatch<SetStateAction<boolean>>;
}

export const ProjectEditPop = (props: ProjectEditPopPropsT) => {
  const navigate = useNavigate();
  const { color } = useSelectTheme();
  const { projectId } = useCurrentProjectState();

  const { closeAction } = props;

  const handleEditConfirmPopClick = () => {
    closeAction(false);
    navigate(`/project_setup/${projectId}`);
  };

  const handleCloseAction = () => {
    closeAction(false);
  };

  const NoticeContents = () => {
    return (
      <>
        <div>
          Adjusting your project tasks and schedule may result in different participants having
          different schedules. While this is allowed and trackable, this may result in more
          challenges when trying to analyze data. You have been warned.
        </div>
      </>
    );
  };

  return (
    <div
      data-testid="task_confirm_delete_pop"
      css={{
        width: "100vw",
        height: "100vh",
        position: "fixed",
        top: 0,
        left: 0,
        background: "#00000040",
        zIndex: 99999,
      }}
    >
      <div
        css={{
          position: "absolute",
          top: "calc(50vh - 145px)",
          left: "calc(50vw - 300px)",
          width: "600px",
          borderRadius: "5px",
          padding: "30px",
          background: color.white,
        }}
      >
        <div
          css={{
            display: "flex",
            alignItems: "top",
            justifyContent: "space-between",
            position: "relative",
          }}
        >
          <Legend
            css={{
              marginBottom: "16px",
            }}
          >
            Are you sure you want to edit your project?
          </Legend>

          <ButtonCancel onClick={handleCloseAction} size={"large"} />
        </div>
        {NoticeContents()}
        {/* divider */}
        <div
          css={{
            width: "100%",
            height: "1px",
            background: color.grey_60,
            marginTop: "32px",
            marginBottom: "20px",
          }}
        ></div>
        <div
          css={{
            width: "100%",
            display: "flex",
            justifyContent: "right",
          }}
        >
          <Button
            onClick={handleCloseAction}
            btnPadding="large"
            btnColor="grey_20"
            textColor={color.grey_600}
            children={"Cancel"}
          />
          <div css={{ width: "12px" }} />
          <Button
            onClick={handleEditConfirmPopClick}
            btnPadding="large"
            btnColor="primary"
            children={"Yes, I Want To Edit Project"}
          />
        </div>
      </div>
    </div>
  );
};
